import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'






export default function SkeletonComponent({
  count
}) {
  return (
    <Skeleton count={count || 5} />
  )
}
